import axios from "axios";
import { toast } from "react-toastify";
import store from "../store";
import { setSubscriptionExpired } from "../store/subscriptionExpired";
/**
 * @description Sends a Get request to api
 * @param {String} route
 * @example "/api/route"
 * @returns Promise<any>
 */

let Get = async (
  route,
  accessToken,
  additionalOptions = {},
  showAlert = true
) => {
  const options = accessToken
    ? {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },

      ...additionalOptions,
    }
    : {
      headers: {
        Accept: "application/json",
      },
    };
  try {
    const response = await axios.get(route, options);
    return response;
  } catch (error) {
    let errorMessage = "";
    Array.isArray(error?.response?.data?.message)
      ? error?.response?.data?.message?.map(
        (item) => (errorMessage = `${errorMessage} • ${item} \n`)
      )
      : (errorMessage = error?.response?.data?.message);
    if (showAlert == true) {
      if (error.message === "Network Error") {
        toast.error(`${error.message} : Please Check Your Network Connection`, {
          position: "top-center",
        });
      } else {
        toast.error(errorMessage, {
          position: "top-center",
        });
      }
    }
  }
};

/**
 * @description Sends a post request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 * @returns Promise<any>
 */

let Post = async (route, data, headers) => {
  try {
    const response = await axios.post(route, data, headers);
    const code = response?.data?.headers?.code;

    if (code === 402) {
      store.dispatch(setSubscriptionExpired(true));

      console.log("402 error")
      throw new Error("Your subscription has expired. Renew now to unlock this feature again");
    }
    return response;
  } catch (error) {

    console.log("ERROR::", error)
    let errorMessage = "";
    if (error.message.startsWith("Your subscription has expired.")) {
      toast.error(error.message);
    }
    Array.isArray(error?.response?.data?.message)
      ? error?.response?.data?.message?.map(
        (item) => (errorMessage = `${errorMessage} • ${item} \n`)
      )
      : (errorMessage = error?.response?.data?.message);
    if (error.message === "Network Error") {
      toast.error(`${error.message} : Please Check Your Network Connection`, {
        position: "top-center",
      });
    } else {
      toast.error(errorMessage, {
        position: "top-center",
      });
    }
  }
};

/**
 * @description Sends a post request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 *   @returns Promise<any>
 */

let Patch = async (route, data, headers) => {
  try {
    const response = await axios.patch(route, data, headers);
    if (response?.data?.headers?.code === 402) {
      store.dispatch(setSubscriptionExpired(true))
    }
    return response
  } catch (error) {
    let errorMessage = "";
    Array.isArray(error?.response?.data?.message)
      ? error?.response?.data?.message?.map(
        (item) => (errorMessage = `${errorMessage} • ${item} \n`)
      )
      : (errorMessage = error?.response?.data?.message);
    if (error.message === "Network Error") {
      toast.error(`${error.message} : Please Check Your Network Connection`, {
        position: "top-center",
      });
    } else {
      toast.error(errorMessage, {
        position: "top-center",
      });
    }
  }
};

/**
 * @description Sends a post request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 *   @returns Promise<any>
 */

let Put = async (route, data, headers) => {
  try {
    const response = await axios.put(route, data, headers);
    if (response?.data?.headers?.code === 402) {
      store.dispatch(setSubscriptionExpired(true))
    }
    return response
  } catch (error) {
    let errorMessage = "";
    Array.isArray(error?.response?.data?.message)
      ? error?.response?.data?.message?.map(
        (item) => (errorMessage = `${errorMessage} • ${item} \n`)
      )
      : (errorMessage = error?.response?.data?.message);
    if (error.message === "Network Error") {
      toast.error(`${error.message} : Please Check Your Network Connection`, {
        position: "top-center",
      });
    } else {
      toast.error(errorMessage, {
        position: "top-center",
      });
    }
  }
};

/**
 * @description Sends a Delete request to api
 * @param {String} route
 * @example "/api/route"
 * @param {Object} data
 * @example {foo:bar}
 *   @returns Promise<any>
 */

let Delete = async (route, data, headers) => {
  try {
    const response = data == null
      ? await axios.delete(route, headers)
      : await axios.delete(route, data, headers);

    if (response?.data?.headers?.code === 402) {
      store.dispatch(setSubscriptionExpired(true))
    }
    return response
    return response;
  } catch (error) {
    let errorMessage = "";
    Array.isArray(error?.response?.data?.message)
      ? error?.response?.data?.message?.map(
        (item) => (errorMessage = `${errorMessage} • ${item} \n`)
      )
      : (errorMessage = error?.response?.data?.message);
    if (error.message === "Network Error") {
      toast.error(`${error.message} : Please Check Your Network Connection`, {
        position: "top-center",
      });
    } else {
      toast.error(errorMessage, {
        position: "top-center",
      });
    }
  }
};
export { Post, Put, Get, Patch, Delete };
